/* global jQuery google */

// eslint-disable-next-line no-unused-vars
const mapStyle = [
	{
		featureType: 'administrative',
		elementType: 'all',
		stylers: [
			{
				'visibility': 'simplified'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'road.arterial',
		elementType: 'all',
		stylers: [{ visibility: 'on' }, { color: '#ffffff' }]
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'poi',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'transit',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }]
	}
]

const DEFAULT_BOUNDS = {
	north: 66.933465987735616,
	south: 49.09466907684661,
	west: -22.145933991390892,
	east: 10.9119244765624913
}

const featureStyleOptions = {
	strokeColor: "#009EE3",
	strokeOpacity: 1,
	strokeWeight: 1,
	fillColor: '#012B4D',
	fillOpacity: 1,
}

const DEFAULT_CENTER = { lat: 56.336000, lng: -3.959389 }
var local_markers = []
const searchInputField = document.getElementById('postcode')
var map
var initMap

	; (function ($) {
		/*
		 *  initMap
		 *
		 *  Will be fired when the Google Maps API has loaded, reassigns global function
		 */
		// eslint-disable-next-line no-func-assign

		initMap = function () {
			$('.google-map').each(function () {
				newMap($(this))
			})
		}

		/*
		 *  render a Google Map onto the selected jQuery element
		 */
		function newMap($el) {
			var $markers = $el.find('.marker')

			if ($el.attr('id') === 'locationMap') {
				//location map
				var center_lat_lng;
				if ($markers.length === 1) {
					center_lat_lng = new google.maps.LatLng($markers.attr('data-lat'), $markers.attr('data-lng'))
				} else {
					center_lat_lng = new google.maps.LatLng($markers[0].attr('data-lat'), $markers[0].attr('data-lng'))
				}

				var args = {
					zoom: parseInt($el.data('zoom')),
					minZoom: 6,
					maxZoom: 20,
					center: center_lat_lng,
					restriction: {
						latLngBounds: DEFAULT_BOUNDS,
						strictBounds: true
					},
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					//mapId: 'cbe432a746555b0c', //Different ID
					styles: mapStyle,
				}

				map = new google.maps.Map($el[0], args)

			} else {
				//general map
				var args = {
					zoom: parseInt($el.data('zoom')),
					minZoom: 6,
					maxZoom: 20,
					center: DEFAULT_CENTER,
					restriction: {
						latLngBounds: DEFAULT_BOUNDS,
						strictBounds: true
					},
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					mapId: 'fb142668fb1fdbc8'  //Different ID
				}

				map = new google.maps.Map($el[0], args)

				/**autocomplete */
				const options = {
					fields: ["formatted_address", "geometry", "name"],
					bounds: DEFAULT_BOUNDS,
					componentRestrictions: { country: 'gb' },
					strictBounds: true,
				}

				const autocomplete = new google.maps.places.Autocomplete(searchInputField, options)
				autocomplete.bindTo("bounds", map);
				autocomplete.addListener('place_changed', async () => {
					var place = autocomplete.getPlace()
					if (!place.geometry) {
						//console.log('no place geometry...');
					} else {
						//console.log(place);
						findClosestMarker(place.geometry.location);
					}
				})

				/**draw layer  */
				let featureLayer = map.getFeatureLayer("COUNTRY");
				// Below Place ID is "UK"
				let placeId = 'ChIJqZHHQhE7WgIReiWIMkOg-MQ';
				// Apply the style to a single boundary.

				featureLayer.style = (options) => {
					if (options.feature.placeId == placeId) {
						return featureStyleOptions;
					}
				}
			}

			// Add marker to map
			$markers.each(function () {
				addMarker($(this), map)
			})

		}

		/*
		 *  add a marker to the selected Google Map
		 */
		function addMarker($marker, map) {
			var latlng = new google.maps.LatLng(
				$marker.attr('data-lat'),
				$marker.attr('data-lng')
			)
			const marker = new google.maps.Marker({
				position: latlng,
				map: map,
				icon: new google.maps.MarkerImage($marker.attr('data-icon')),
				title: $marker.attr('data-title'),
			})

			//map.markers.push(marker)
			// if marker contains HTML, add it to an infoWindow
			if ($marker.html()) {

				const infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				})

				marker.infowindow = infowindow;

				marker.addListener("click", () => {

					//close all markers;
					hideAnyMarkerInfowindow()
					//open clicked one
					infowindow.open({
						anchor: marker,
						map,
					});

				});
			}

			local_markers.push(marker)

			return marker;
		}

		/**
		* Find the closest marker and popup
		*	@arg place.location
		*/
		function findClosestMarker(location) {
			let current_position = { lat: location.lat(), lng: location.lng() }
			let selected = local_markers.reduce(function (prev, curr) {
				var cpos = google.maps.geometry.spherical.computeDistanceBetween(current_position, curr.position);
				var ppos = google.maps.geometry.spherical.computeDistanceBetween(current_position, prev.position);

				return cpos < ppos ? curr : prev;
			})

			//console.log(selected);
			new google.maps.event.trigger(selected, 'click');
		}

		/**
		* close any marker infowindow
		*/
		function hideAnyMarkerInfowindow() {
			for (var i = 0; i < local_markers.length; i++) {
				local_markers[i].infowindow.close()
			}
		}

		/**
		*	close infowindow when start searching
		*/
		if (searchInputField != null) {
			searchInputField.addEventListener('keyup', () => { hideAnyMarkerInfowindow() }, false);
		}
		/**
		 *  center the map, showing all markers attached
		 */
		function centerMap(map) {
			var bounds = new google.maps.LatLngBounds()
			// loop through all markers and create bounds
			$.each(local_markers, function (i, marker) {
				var latlng = new google.maps.LatLng(
					marker.position.lat(),
					marker.position.lng()
				)
				bounds.extend(latlng)
			})
			if (local_markers === 1) {
				map.setCenter(bounds.getCenter())
			} else {
				map.fitBounds(bounds)
			}
		}

	})(jQuery)
